export default {
  'createbusinessprofile.createbusinessprofile': 'Create Business Profile',
};
